import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { Flex } from "components/common/Responsive";
import ImageWrapper from "components/common/ImageWrapper";
import Menu from "components/common/Menu";
import menasLogo from "static/images/top-logo.png";
import { gql, useQuery, useReactiveVar } from "@apollo/client";
import { getRandomInt } from "utils/math";
import { headerImageCached } from "apollo/cache";

const TopWrapper = styled(Flex)`
  height: 422px;
  background: transparent url(${(props) => props.image}) top / cover;
  @media (max-width: 767px) {
    height: 290px;
  }
`;

const LogoWrapper = styled(Flex)`
  position: relative;
  margin: 0 auto;
`;

const Logo = styled(ImageWrapper)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  height: 390px;
  @media (max-width: 767px) {
    height: 250px;
  }
`;

const PageWrapper = ({ children }) => {
  const history = useHistory();
  const images = useReactiveVar(headerImageCached);
  useQuery(query, {
    skip: images.length > 0,
    onCompleted: (data => {
      headerImageCached(data?.pagrindini?.homepageItems)
    })
  });
  const randomNumber = getRandomInt(images?.length - 1);
  const randomItem = images[randomNumber];
  const image = randomItem?.background?.url;
  return (
    <Flex flexDirection="column" width={1}>
      <TopWrapper
        px={["24px", "24px", 0]}
        position="relative"
        width={1}
        image={image}
      >
        <LogoWrapper maxWidth={"1240px"} width={1}>
          <Logo
            onClick={() => history.push("/")}
            src={menasLogo}
            alt="Teatras Menas Logotipas"
          />
        </LogoWrapper>
      </TopWrapper>
      <Menu />
      <Flex alignItems="center" flexDirection="column" width={1} mx={"auto"}>
        {children}
      </Flex>
    </Flex>
  );
};

const query = gql`
  query LoadHomepage {
    pagrindini {
      homepageItems {
        background {
          url
        }
      }
    }
  }
`;

PageWrapper.propTypes = {
  children: PropTypes.node,
};

export default PageWrapper;
